import { UPDATE_PERMANENT_DECREE_MUTATION } from "services/web/api-decree.const";
import { UpdatePermanentDecreeInput } from "@/types/gql/graphql";
import { useTrackedMutation } from "@/hooks/apollo-insights-hooks";

export const usePermanentDecree = (refetchDecree: () => void) => {
  const [updatePermanentDecree] = useTrackedMutation(UPDATE_PERMANENT_DECREE_MUTATION, {
    actionName: "UpdatePermanentDecree",
  });
  const updatePermanentDecreeCategory = async (permanentInput: UpdatePermanentDecreeInput) => {
    await updatePermanentDecree({
      variables: { updateDecreeInput: permanentInput },
      onCompleted: () => {
        refetchDecree();
      },
    });
  };

  return {
    updatePermanentDecreeCategory,
  };
};
